<div class="text-error-500 font-semibold cursor-pointer underline hover:text-error-700" (click)="handleClick()">
    {{ 'admin.mandatory_data_missing' | transloco }}
</div>